import ArrowLeft from '@eduzz/houston-icons/ArrowLeft';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import { Link } from 'react-router-dom';
import ChargebackAlert from 'v2/components/Shared/ChargebackAlert';
import GlobalWarning from 'v2/components/Shared/GlobalWarning';

import styles from './styles';

interface IProps {
  title: string | React.ReactNode;
  extra?: React.ReactNode;
  helpLink?: string;
  goBackTo?: string;
  action?: React.ReactNode;
  additionalContent?: React.ReactNode;
}

function TopPage({ title, extra, helpLink, goBackTo, action, additionalContent }: IProps) {
  const classes = styles();

  return (
    <>
      <Grid container>
        <Grid xs={12}>
          <GlobalWarning />
          <ChargebackAlert />
        </Grid>

        <Grid xs={12}>
          <div className={classes.root}>
            <div>
              {!!goBackTo && (
                <Link to={goBackTo} id='go-back-button' className={classes.back}>
                  <ArrowLeft aria-hidden='true' />
                  Voltar
                </Link>
              )}
              <h1 className={classes.title}>{title}</h1>
              <div className={classes.extraContent}>{extra || ''}</div>
            </div>
            {!!action && <>{action}</>}

            {additionalContent}

            {!!helpLink && (
              <Button className={classes.button} variant='outlined' href={helpLink} target='_blank'>
                Ajuda
              </Button>
            )}
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default TopPage;
